import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getBalanceTypes, saveBalanceTypesBatch } from '../../api/balanceTypes';
import type { BalanceType } from '../../types/BalanceType';
import { t } from '../../i18n/t';

const balanceTypesColumnDefs: ColDef<BalanceType>[] = [
  {
    field: 'balanceTypeId',
    headerName: t('balanceTypes.columns.balanceTypeId'),
    width: 140,
    // Natural PK: editable on Add only.
    editable: (params: EditableCallbackParams<BalanceType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'balanceTypeName',
    headerName: t('balanceTypes.columns.balanceTypeName'),
    flex: 1,
    editable: true,
  },
];

const newBalanceTypeDefaults = (): Partial<BalanceType> => ({
  balanceTypeId: 0,
  balanceTypeName: '',
});

export function BalanceTypesPage() {
  return (
    <LopCrudPage<BalanceType>
      resourceCode="balanceTypes"
      titleKey="balanceTypes.pageTitle"
      idField="balanceTypeId"
      getRows={getBalanceTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBalanceTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={balanceTypesColumnDefs}
      newRowDefaults={newBalanceTypeDefaults}
    />
  );
}
